import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  show(event) {
    const selected = event.currentTarget.dataset.panel

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panelName !== selected)
    })

    this.element.querySelectorAll(".toggle-panel-tab").forEach((tab) => {
      const isActive = tab.dataset.panel === selected
      tab.classList.toggle("text-primary", isActive)
      tab.classList.toggle("border-primary", isActive)
      tab.classList.toggle("text-ink-muted", !isActive)
      tab.classList.toggle("border-transparent", !isActive)
    })
  }
}